import { TraderBalance } from "@components/balance";
import { FlexLoader } from "@components/loader";
import { ProfitSmall } from "@components/profit-small";
import { TransferMoneyModal } from "@components/transfer-money-modal";
import { Disputes } from "@features/appeals/components/disputes/trader";
import { useBalance } from "@features/balance";
import { balanceIsValid } from "@features/balance/helpers";
import { Transactions } from "@features/order/components/transactions";
import { useCallback, useEffect, useState } from "react";
import styles from "./deals.module.scss";
import { useWebSocket } from "@request/useWebsocket";
import { WebsocketUpdateType } from "@request/websocket";

export const DealsPage = () => {
  const { state, getSaveFrozenBalance, getBalances } = useBalance();

  const [selectedPayType, setSelectedPayType] = useState<"payIn">();
  const resetSelectedPayType = useCallback(() => {
    setSelectedPayType(undefined);
  }, []);
  const { lastMessage } = useWebSocket();

  const websocketTypesToUpdateBalance = [
    WebsocketUpdateType.Balance,
    WebsocketUpdateType.Withdrawal,
    WebsocketUpdateType.Appeal,
    WebsocketUpdateType.Order,
    WebsocketUpdateType.PayOut,
  ];

  useEffect(() => {
    if (
      lastMessage &&
      websocketTypesToUpdateBalance.includes(lastMessage.type)
    ) {
      getBalances();
      getSaveFrozenBalance();
    }
  }, [lastMessage]);
  useEffect(() => {
    getBalances();
    getSaveFrozenBalance();
  }, []);
  if (!balanceIsValid(state)) {
    return null;
  }

  const ern = state.payIn + state.payOut;

  return (
    <>
      <div>
        <div className={styles.top}>
          <div className={styles.topLeft}>
            {state.loading || state.loadingSave ? (
              <FlexLoader />
            ) : (
              <>
                <TraderBalance
                  className={styles.balance}
                  type="trusted"
                  balance={state.trust}
                  saveBalance={state.save}
                  withRubles={false}
                />
                <TraderBalance
                  type="frozen"
                  balance={state.frozen}
                  withRubles={false}
                />
                {!!state.payIn && (
                  <TraderBalance
                    className={styles.payIn}
                    type="profit"
                    balance={state.payIn}
                    withRubles={false}
                    onClick={() => setSelectedPayType("payIn")}
                  />
                )}
              </>
            )}
          </div>
          <ProfitSmall profit={ern} />
        </div>

        <Disputes />
        <Transactions />
      </div>
      <TransferMoneyModal type={selectedPayType} hide={resetSelectedPayType} />
    </>
  );
};
